import React, {useMemo} from "react";
import {backgroundColorList} from "../../utils/dashboardUtils";

const TestConfigChart = ({period, testResultPoints, onePointWidth}) => {
    const bars = useMemo(() => {
        if (!testResultPoints) return null;

        let left = 0, pointsCount = 0;
        const entries = Object.entries(testResultPoints);

        return entries.map(([test, maxPoints], i) => {
            const width = maxPoints * onePointWidth;
            const color = backgroundColorList[i + (period?.levelPointsConfig?.length || 0)];
            const barStyle = { width: `${width}%`, left: `${left}%` };
            left += width;

            const startLabel = pointsCount;
            pointsCount += maxPoints;

            return (
                <div className="dashboard-charts-level-points-bar" key={`${test}-${i}`} style={barStyle}>
                    <p style={{color}}>{`Test ${test}`}</p>
                    <div style={{backgroundColor: color}}/>
                    <label style={{color}}>{`${startLabel}b`}</label>
                    <label style={{color}}>{`${pointsCount}b`}</label>
                </div>
            );
        });
    }, [testResultPoints, onePointWidth, period]);

    if (!bars) return null;

    return <div style={{height: 100}}>{bars}</div>;
};

export default TestConfigChart;
